import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';

import type { Id } from '../../api/models';

import {
  type ApiError,
  type ApiResponse,
  addActionNameToMutationResult,
  useAxiosInstance,
} from './utils';

export type UseMarkConversationAsReadVariables = {
  id: Id;
};

async function markConversationAsReadMutationFn(
  axiosInstance: Promise<AxiosInstance>,
  vars: UseMarkConversationAsReadVariables,
) {
  const instance = await axiosInstance;

  const data = instance.put(`conversations/${vars.id}/mark_as_read`);
  return data;
}

export function useMarkConversationAsRead() {
  const axiosInstance = useAxiosInstance();
  const client = useQueryClient();

  const mutation = useMutation<ApiResponse, ApiError, UseMarkConversationAsReadVariables>({
    mutationFn: (vars: UseMarkConversationAsReadVariables) =>
      markConversationAsReadMutationFn(axiosInstance, vars),
    onSuccess: () => client.invalidateQueries({ queryKey: ['third-party-cases'] }),
    meta: { suppressSuccessNotification: true },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    UseMarkConversationAsReadVariables,
    'markConversationAsRead'
  >('markConversationAsRead', mutation);
}
